import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useUsage } from '../../hooks/useUsage';

const AppShell = styled.div`
  display: grid;
  grid-template-columns: 232px 1fr;
  min-height: 100vh;
  background: var(--bg2);

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Content = styled.main`
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
`;

const MobileSidebarOverride = styled.div`
  @media (max-width: 720px) {
    display: none;
  }
`;

interface LayoutProps {
  userName: string;
  onSignOut: () => void;
}

export default function Layout({ userName, onSignOut }: LayoutProps) {
  const { usage, isLoading: usageLoading } = useUsage();

  return (
    <AppShell>
      <MobileSidebarOverride>
        <Sidebar usage={usage} usageLoading={usageLoading} />
      </MobileSidebarOverride>
      <MainColumn>
        <Navbar
          userName={userName}
          onSignOut={onSignOut}
          usage={usage}
          usageLoading={usageLoading}
        />
        <Content>
          <Outlet />
        </Content>
      </MainColumn>
    </AppShell>
  );
}
